import * as tslib_1 from "tslib";
import { BaseService } from '../../_helpers';
import { HttpClient } from '@angular/common/http';
import { DictionaryEntity } from '../entity/dictionaryEntity';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var IncidentSourceDictionaryService = /** @class */ (function (_super) {
    tslib_1.__extends(IncidentSourceDictionaryService, _super);
    function IncidentSourceDictionaryService(http) {
        var _this = _super.call(this, 'config/incidentSources/idAndNames', DictionaryEntity) || this;
        _this.http = http;
        return _this;
    }
    IncidentSourceDictionaryService.ngInjectableDef = i0.defineInjectable({ factory: function IncidentSourceDictionaryService_Factory() { return new IncidentSourceDictionaryService(i0.inject(i1.HttpClient)); }, token: IncidentSourceDictionaryService, providedIn: "root" });
    return IncidentSourceDictionaryService;
}(BaseService));
export { IncidentSourceDictionaryService };
